import { Ressource } from '../models/ressource.model';

export type RessourceState = {
  ressources: Ressource[];
  filtre: string;
};

export const initialState: RessourceState = {
  ressources: [],
  filtre: '',
};
